module.exports = __webpack_public_path__ + "static/media/tree-alt.15b6a6b9.svg";